var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 43,
    viewBox: "0 0 85 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.245 8.43704C20.245 8.85219 20.4106 9.1875 20.7416 9.45894C21.0726 9.73038 21.4955 9.85812 21.9921 9.84215C22.4886 9.84215 22.9116 9.69845 23.2426 9.41104C23.5736 9.12363 23.7391 8.77235 23.7391 8.35721C23.7391 7.974 23.5736 7.63868 23.2426 7.38321C22.9116 7.12774 22.4886 7 21.9921 7C21.4955 7 21.0726 7.14371 20.7416 7.41515C20.4106 7.68659 20.245 8.03786 20.245 8.43704Z",
    fill: "url(#paint0_linear_980_277404)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3529 11.5347H20.6128V21.6898H23.3529V11.5347Z",
    fill: "url(#paint1_linear_980_277404)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0408 13.8818C14.5259 13.0994 13.8271 12.4927 12.926 12.0616C12.0432 11.6305 11.0134 11.4229 9.89165 11.4229C9.11928 11.4229 8.43886 11.5347 7.79522 11.7582C7.15158 11.9818 6.59988 12.3171 6.14014 12.7641V7.57482H3.40007V21.6578H5.99302V20.3485C6.45277 20.8275 7.00446 21.1948 7.66649 21.4343C8.32852 21.6738 9.06411 21.8015 9.87326 21.8015C11.0134 21.8015 12.0249 21.594 12.926 21.1629C13.8271 20.7317 14.5259 20.125 15.0408 19.3266C15.5557 18.5283 15.8131 17.6181 15.8131 16.5962C15.8131 15.5744 15.5557 14.6642 15.0408 13.8818ZM13.0363 16.6122C13.0363 17.5543 12.7053 18.3367 12.0616 18.9115C11.3996 19.4863 10.5721 19.7897 9.57902 19.7897C8.93538 19.7897 8.34691 19.6619 7.81361 19.4065C7.2803 19.135 6.87573 18.7678 6.56311 18.2888C6.25048 17.8098 6.10336 17.2509 6.10336 16.6122C6.10336 15.9735 6.25048 15.4147 6.56311 14.9357C6.87573 14.4407 7.2803 14.0734 7.81361 13.818C8.32852 13.5625 8.91699 13.4348 9.57902 13.4348C10.5905 13.4348 11.418 13.7381 12.0616 14.313C12.7053 14.8878 13.0363 15.6542 13.0363 16.6122Z",
    fill: "url(#paint2_linear_980_277404)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1274 7.57482H31.8674V21.6738H29.1274V7.57482Z",
    fill: "url(#paint3_linear_980_277404)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3819 7.57482H37.6418V21.6738H40.3819V7.57482Z",
    fill: "url(#paint4_linear_980_277404)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.285 9.45894C45.954 9.1875 45.7885 8.85219 45.7885 8.43704C45.7885 8.03786 45.954 7.68659 46.285 7.41515C46.616 7.14371 47.039 7 47.5355 7C48.032 7 48.455 7.12774 48.786 7.38321C49.117 7.63868 49.2825 7.974 49.2825 8.35721C49.2825 8.77235 49.117 9.12363 48.786 9.41104C48.455 9.69845 48.032 9.84215 47.5355 9.84215C47.039 9.85812 46.616 9.73038 46.285 9.45894Z",
    fill: "url(#paint5_linear_980_277404)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1563 11.5347H48.8963V21.6898H46.1563V11.5347Z",
    fill: "url(#paint6_linear_980_277404)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5051 19.2947C55.0384 20.0931 55.774 20.6998 56.7303 21.1469C57.6682 21.594 58.7348 21.8175 59.9301 21.8175C61.1254 21.8175 62.192 21.594 63.1483 21.1469C64.1046 20.6998 64.8402 20.0931 65.3735 19.2947C65.9068 18.5123 66.1642 17.6181 66.1642 16.6122C66.1642 15.6063 65.9068 14.7121 65.3735 13.9297C64.8402 13.1473 64.1046 12.5406 63.1483 12.0935C62.192 11.6464 61.1254 11.4229 59.9301 11.4229C58.7532 11.4229 57.6866 11.6464 56.7303 12.0935C55.774 12.5246 55.0384 13.1473 54.5051 13.9297C53.9718 14.7121 53.7144 15.6063 53.7144 16.6122C53.7144 17.6022 53.9718 18.4963 54.5051 19.2947ZM63.4058 16.6122C63.4058 17.5543 63.0747 18.3367 62.4127 18.9115C61.7691 19.4863 60.9231 19.7897 59.9117 19.7897C58.9003 19.7897 58.0727 19.5023 57.4291 18.9115C56.7855 18.3367 56.4544 17.5702 56.4544 16.6122C56.4544 15.6702 56.7855 14.9037 57.4291 14.313C58.0727 13.7222 58.9003 13.4348 59.9117 13.4348C60.9231 13.4348 61.7507 13.7381 62.4127 14.313C63.0747 14.8878 63.4058 15.6542 63.4058 16.6122Z",
    fill: "url(#paint7_linear_980_277404)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1519 12.5406C82.0346 13.2911 82.4943 14.3928 82.4943 15.8618V21.6738H79.7543V16.1651C79.7543 15.271 79.5152 14.6163 79.0371 14.1533C78.5589 13.7062 77.8785 13.4827 76.9774 13.4827C75.966 13.4827 75.1752 13.7381 74.5868 14.265C73.9983 14.792 73.7041 15.5424 73.7041 16.5324V21.6578H70.964V11.5027H73.5753V12.812C74.0351 12.349 74.6051 11.9818 75.2856 11.7422C75.966 11.5027 76.7384 11.375 77.6027 11.375C79.0922 11.4229 80.2692 11.7901 81.1519 12.5406Z",
    fill: "url(#paint8_linear_980_277404)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.647 32.0436C23.647 30.5108 23.2056 29.3771 22.3413 28.6107C21.477 27.8602 20.3185 27.477 18.8473 27.4611C18.0014 27.4611 17.229 27.6048 16.5118 27.8762C15.813 28.1476 15.2061 28.5468 14.7464 29.0737C14.3418 28.5309 13.8085 28.1317 13.1465 27.8602C12.5028 27.5888 11.7488 27.4611 10.9213 27.4611C10.2041 27.4611 9.54207 27.5728 8.93521 27.7804C8.32835 27.988 7.81343 28.3073 7.37208 28.7225V27.6367H3.3999V37.9355H7.55598V32.826C7.55598 32.0596 7.73988 31.4848 8.12607 31.1016C8.49386 30.7184 9.00877 30.5267 9.65241 30.5267C10.8477 30.5267 11.4546 31.2293 11.4546 32.6344V37.9355H15.6107V32.826C15.6107 32.0596 15.7946 31.4848 16.1808 31.1016C16.5486 30.7184 17.0635 30.5267 17.6887 30.5267C18.2588 30.5267 18.7002 30.7024 19.0128 31.0377C19.3254 31.373 19.4909 31.9159 19.4909 32.6344V37.9355H23.647V32.0436Z",
    fill: "url(#paint9_linear_980_277404)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4651 31.7658H32.6212V37.9515H28.4651V31.7658Z",
    fill: "url(#paint10_linear_980_277404)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1282 32.0436C50.1282 30.5108 49.6869 29.3771 48.7858 28.6107C47.9031 27.8602 46.7077 27.477 45.2182 27.4611C44.4642 27.4611 43.7654 27.5728 43.1218 27.7964C42.4965 28.0199 41.9264 28.3392 41.4667 28.7544V27.6367H37.5129V37.9355H41.669V32.9537C41.669 32.1554 41.8896 31.5327 42.3126 31.1335C42.7356 30.7343 43.3057 30.5267 44.0229 30.5267C45.3285 30.5267 45.9722 31.2293 45.9722 32.6344V37.9355H50.1282V32.0436Z",
    fill: "url(#paint11_linear_980_277404)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7272 23.8365V37.9355H63.7734V36.9136C63.001 37.7119 61.8425 38.1111 60.2977 38.1111C59.2127 38.1111 58.2381 37.8876 57.337 37.4565C56.4359 37.0254 55.7371 36.4026 55.2222 35.5883C54.7073 34.774 54.4498 33.8319 54.4498 32.7781C54.4498 31.7083 54.7073 30.7822 55.2222 29.9679C55.7371 29.1695 56.4359 28.5468 57.337 28.1157C58.2197 27.6846 59.2127 27.477 60.2977 27.477C61.7137 27.477 62.7987 27.8283 63.5895 28.5468V23.8365H67.7272ZM62.9275 34.5984C63.3872 34.1672 63.6263 33.5605 63.6263 32.7781C63.6263 32.0117 63.4056 31.4209 62.9459 30.9898C62.4861 30.5587 61.8976 30.3511 61.162 30.3511C60.4265 30.3511 59.838 30.5746 59.3599 30.9898C58.9001 31.4209 58.6611 32.0117 58.6611 32.7781C58.6611 33.5445 58.9001 34.1513 59.3599 34.5984C59.8196 35.0295 60.4265 35.253 61.162 35.253C61.8609 35.253 62.4493 35.0295 62.9275 34.5984Z",
    fill: "url(#paint12_linear_980_277404)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6442 37.0573C72.2327 37.3766 73.0051 37.6321 73.9613 37.8237C74.9176 38.0153 75.8923 38.1111 76.8669 38.1111C78.099 38.1111 79.1656 37.9674 80.0484 37.68C80.9311 37.3766 81.5931 36.9775 82.0528 36.4665C82.5126 35.9556 82.7332 35.3648 82.7332 34.7261C82.7332 33.9437 82.4942 33.321 82.0161 32.8899C81.5379 32.4428 80.9862 32.1394 80.3426 31.9798C79.6989 31.8201 78.8898 31.6764 77.9151 31.5486C77.1428 31.4528 76.5911 31.357 76.2601 31.2612C75.929 31.1654 75.7635 30.9898 75.7635 30.7503C75.7635 30.5267 75.9107 30.3511 76.2233 30.2234C76.5359 30.0956 77.014 30.0318 77.6761 30.0318C78.9082 30.0318 80.0484 30.2872 81.0966 30.7982L82.3471 28.3393C81.7954 28.0678 81.0782 27.8602 80.2323 27.7006C79.3863 27.5569 78.5404 27.477 77.6761 27.477C76.4623 27.477 75.4141 27.6207 74.5498 27.9241C73.6855 28.2115 73.0235 28.6267 72.5637 29.1376C72.104 29.6486 71.8833 30.2393 71.8833 30.894C71.8833 31.6923 72.1224 32.3151 72.6005 32.7621C73.0786 33.2092 73.6487 33.5126 74.3107 33.6723C74.9912 33.8319 75.7819 33.9756 76.7382 34.0714C77.4922 34.1513 78.0255 34.2471 78.3749 34.3429C78.7243 34.4387 78.8898 34.5824 78.8898 34.8219C78.8898 35.0614 78.7427 35.2211 78.4668 35.3488C78.191 35.4606 77.7128 35.5245 77.0324 35.5245C76.3152 35.5245 75.5612 35.4446 74.8257 35.269C74.0717 35.1093 73.428 34.8698 72.8947 34.5824L71.6442 37.0573Z",
    fill: "url(#paint13_linear_980_277404)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5126 29.4144C31.5362 29.4144 32.366 28.6943 32.366 27.8061C32.366 26.9179 31.5362 26.1978 30.5126 26.1978C29.489 26.1978 28.6591 26.9179 28.6591 27.8061C28.6591 28.6943 29.489 29.4144 30.5126 29.4144ZM30.5126 30.844C32.4461 30.844 34.0135 29.4839 34.0135 27.8061C34.0135 26.1283 32.4461 24.7682 30.5126 24.7682C28.5791 24.7682 27.0117 26.1283 27.0117 27.8061C27.0117 29.4839 28.5791 30.844 30.5126 30.844Z",
    fill: "url(#paint14_linear_980_277404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_980_277404",
    x1: -7.61862,
    y1: 12.6589,
    x2: 107.525,
    y2: 12.6589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A6CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24EE12"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.094af1b2.svg";
export { ForwardRef as ReactComponent };